export default {
    name: 'v5-icon-man',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M795.19 176.917H682.666a32 32 0 110-64h192a32 32 0 0132 32v192a32 32 0 11-64 0v-116.97L736.8 325.813a350.613 350.613 0 0184.533 228.854c0 194.4-157.6 352-352 352s-352-157.6-352-352 157.6-352 352-352a350.539 350.539 0 01221.6 78.506L795.19 176.917zm-325.857 665.75c159.062 0 288-128.939 288-288s-128.938-288-288-288-288 128.938-288 288 128.939 288 288 288z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
